import { useQuery } from '@tanstack/react-query';
import { Select } from 'antd';
import { ReactNode } from 'react';
import { getIssueCategoriesDropdown } from '@martech-solution/utils/apis';

interface Props {
  value?: number;
  style?: React.CSSProperties | undefined;
  allowClear?: boolean | undefined;
  onChange?: (value: number) => void;
  placeholder?: ReactNode;
  popupMatchSelectWidth?: number;
}

export default function IssueCategorieSelect({
  value,
  style,
  allowClear = true,
  onChange,
  placeholder,
  popupMatchSelectWidth
}: Props) {
  const issueCategoriesDropdownQuery = useQuery({
    queryKey: ['issueCategoriesDropdownQuery'],
    queryFn: () => getIssueCategoriesDropdown(),
    staleTime: 60 * 1000
  });

  return (
    <Select
      popupMatchSelectWidth={popupMatchSelectWidth ?? 400}
      allowClear={allowClear}
      value={issueCategoriesDropdownQuery.isFetching ? undefined : value}
      style={style}
      placeholder={placeholder}
      onChange={onChange}
      optionLabelProp='selectedShow'
      options={issueCategoriesDropdownQuery.data?.data.map((data) => ({
        value: data.id,
        label: `${data.code} - ${data.name}`,
        selectedShow: `${data.name}`
      }))}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      loading={issueCategoriesDropdownQuery.isFetching}
    />
  );
}
